/* unplugin-vue-components disabled */import { render } from "./ScorePanel.vue?vue&type=template&id=1c8b6658&scoped=true"
import script from "./ScorePanel.vue?vue&type=script&lang=js"
export * from "./ScorePanel.vue?vue&type=script&lang=js"

import "./ScorePanel.vue?vue&type=style&index=0&id=1c8b6658&scoped=true&lang=css"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c8b6658"]])

export default __exports__